module.exports = __webpack_public_path__ + "img/onb4.fe164cad.svg";